import React, { useState } from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { convertTimeLetter } from '@helpers';

import { font } from '@styles/fonts';

const LineTime = ({ C, color, time, timeSize, setTimeSize, isTimeRightAlign, timePosition }) => {
  const isDay = Number(time.d) > 0;
  return (
    <View
      style={{
        flexDirection: 'row',
        opacity: timeSize ? 1 : 0,
        marginLeft: isTimeRightAlign ? 'auto' : timePosition,
        marginRight: isTimeRightAlign ? scale(6) : 0,
      }}
      onLayout={(event) => {
        const { width } = event.nativeEvent.layout;
        setTimeSize(width);
      }}
    >
      <Text>
        <Text style={[font['Button 1'], { color: C(color) }]}>{isDay ? time.d : time.h}</Text>
        <Text style={[font['Caption 1'], { color: C(color) }]}>{i18n.t(isDay ? 'd' : 'h')}</Text>
      </Text>
      <Text style={{ marginLeft: scale(6) }}>
        <Text style={[font['Button 1'], { color: C(color) }]}>{isDay ? time.h : time.m}</Text>
        <Text style={[font['Caption 1'], { color: C(color) }]}>{i18n.t(isDay ? 'h' : 'm')}</Text>
      </Text>
    </View>
  );
};

export default ({ name, backgroundColor, color, seconds, pxInSecond, zIndex, C, fromStart, offset, elementWidth }) => {
  const [timeSize, setTimeSize] = useState(0);
  const [labelSize, setLabelSize] = useState(0);
  const time = convertTimeLetter(seconds, false, false, false);

  const left = pxInSecond * offset > 1 ? pxInSecond * offset - 1 : pxInSecond * offset;
  const leftAndLineSize = pxInSecond * (seconds + (fromStart ? 0 : offset));
  const rightSpace = elementWidth - leftAndLineSize;

  const isTimeRightAlign = rightSpace - scale(20) <= timeSize;

  const timePosition = isTimeRightAlign ? 0 : Math.max(scale(6), leftAndLineSize - labelSize + scale(6));

  const rightOffset = !fromStart && elementWidth - left < timeSize ? timeSize : 0;

  return (
    <View style={{ width: '100%', height: scale(37), justifyContent: 'center' }}>
      <View
        style={{
          width: '100%',
          height: scale(21),
          zIndex,
          paddingHorizontal: scale(4),
        }}
      >
        {!fromStart && (
          <View
            style={{
              width: scale(1),
              backgroundColor: C(backgroundColor),
              position: 'absolute',
              left: pxInSecond * offset + pxInSecond * seconds - 1,
              height: scale(25),
              top: scale(-20),
            }}
          ></View>
        )}
        {!fromStart && (
          <View
            style={{
              width: scale(1),
              backgroundColor: C(backgroundColor),
              position: 'absolute',
              left: left,
              height: scale(25),
              bottom: scale(-20),
            }}
          ></View>
        )}
        <View
          style={{
            width: pxInSecond * seconds + (fromStart ? 0 : 1),
            backgroundColor: C(backgroundColor),
            borderRadius: scale(4),
            position: 'absolute',
            height: scale(21),
            left: fromStart ? 0 : left,
          }}
        >
          {isTimeRightAlign && !rightOffset && <LineTime {...{ C, color, time, timeSize, setTimeSize, isTimeRightAlign, timePosition }} />}
        </View>
        <View
          style={[
            {
              alignItems: 'center',
              flexDirection: 'row',
            },
            isTimeRightAlign && {
              justifyContent: 'space-between',
            },
          ]}
        >
          <View
            onLayout={(event) => {
              const { width } = event.nativeEvent.layout;
              setLabelSize(width);
            }}
            style={{ maxWidth: elementWidth - timeSize - scale(24) }}
          >
            <Text numberOfLines={1} style={[font['Button 1'], { color: C(color) }]}>
              {i18n.t(name)}
            </Text>
          </View>
          {(!isTimeRightAlign || !!rightOffset) && <LineTime {...{ C, color, time, timeSize, setTimeSize, isTimeRightAlign, timePosition }} />}
        </View>
      </View>
    </View>
  );
};
